const OrderTypes = Object.freeze({
  shortestDistanceFirst: 'shortestDistanceFirst',
  longestDistanceFirst: 'longestDistanceFirst',
  lowestPriceFirst: 'lowestPriceFirst',
  highestPriceFirst: 'highestPriceFirst',
})

const sortFactory = (order = OrderTypes.shortestDistanceFirst, store) => {
  const price = (cube) => {
    const price = store.getters.producerPrices(cube.cubeName)
    if (price && price.currentPrice)
      return store.getters.producerPrices(cube.cubeName).currentPrice
  }

  switch (order) {
    case OrderTypes.shortestDistanceFirst:
      return (cubeA, cubeB) => cubeA.distanceFromMe - cubeB.distanceFromMe
    case OrderTypes.longestDistanceFirst:
      return (cubeA, cubeB) => cubeB.distanceFromMe - cubeA.distanceFromMe
    case OrderTypes.lowestPriceFirst:
      return (cubeA, cubeB) => price(cubeA) - price(cubeB)
    case OrderTypes.highestPriceFirst:
      return (cubeA, cubeB) => price(cubeB) - price(cubeA)
  }
}

export { OrderTypes, sortFactory }
